import { createTheme } from '@mui/material/styles';
import { merge } from 'lodash';

import components from './components';
import palette from './palette';
import typography from './typography';

export function getTheme(customPalette: any = {}) {
	return createTheme({
		components,
		breakpoints: {
			values: {
				xs: 576,
				sm: 768,
				md: 992,
				lg: 1200,
				xl: 1400,
			},
		},
		typography,
		palette: merge(palette, customPalette),
	});
}

export default getTheme();
